export default __webpack_public_path__ + "static/Group 86-236cb602c7cd9ed784d3919fceff2b16.jpg";